var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    width: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.233 22.267l-2.612-.233.893-8.576 2.612.232zM12.36 22.233l-.893-8.576 2.611-.232.893 8.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.02 12.348c-1.094-2.792-3.412-5.017-6.341-6.109-2.1-5.016-8.222-7.523-13.688-5.582C11.28 1.628 9.093 3.61 8 6.118c-5.773 2.104-8.615 8.13-6.341 13.47 1.18 2.791 3.63 4.976 6.647 5.987V35H27.24v-9.304c5.86-1.982 8.921-7.928 6.779-13.349zM24.66 32.532H10.93v-2.508H24.66zm5.86-12.014a8.729 8.729 0 01-4.898 3.156l-.043-.04c-.481.12-.875.485-.962.93v3.033H10.93v-2.912c0-.566-.394-1.011-.963-1.173-4.591-1.133-7.346-5.46-6.166-9.708.525-1.82 1.706-3.439 3.411-4.53v.566c0 .687.569 1.213 1.312 1.213.744 0 1.312-.526 1.312-1.213 0-4.086 3.586-7.362 7.96-7.362 4.416 0 7.958 3.317 7.958 7.362 0 .687.569 1.213 1.312 1.213s1.312-.526 1.312-1.213v-.445c3.936 2.548 4.898 7.524 2.143 11.124z"
  }))));
}

export default __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/cook-1cbc5e0639e08a4e988fc6f5538a4d1c.svg";
export { SvgCook as Component };